// extracted by mini-css-extract-plugin
module.exports = {"label":"Projects_label__lBT0q","flex":"Projects_flex__1SF3-","flexBetween":"Projects_flexBetween__xFbsL"};